import { Grid } from "@material-ui/core";
import React, {  } from "react";
import Calendar from "../../common/Calendar";

export interface BuilderDateSelectorProps {
  onChange: (dates: Date[]) => void;
}

const BuilderDateSelector: React.FC<BuilderDateSelectorProps> = ({ onChange }) => {
  return (
    <Grid container={true} direction="column" spacing={2}>
      <Calendar onChange={onChange}/>
    </Grid>
  );
};

export default BuilderDateSelector;
